import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { BiEdit } from "react-icons/bi";
import Selects from "react-select";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import SweetAlert from "react-bootstrap-sweetalert";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import selectStyles from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import dashboardStyles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import { localApi, credentials } from "utils/imgApi";

const useStyles = makeStyles(styles);
const useStyleSweet = makeStyles(styleSweet);
const useSelectStyles = makeStyles(selectStyles);
const useDashboardStyles = makeStyles(dashboardStyles);

export default function ClientTypeChange() {
    const [items, setItems] = useState([]);
    const [simpleSelect, setSimpleSelect] = useState(null);
    const [simpleSelectErr, setSimpleSelectErr] = useState("");
    const [clientid, setClientid] = useState(null);
    const [typeItem, setTypeItem] = useState([]);
    const [type, setType] = useState("");
    const [typeErr, setTypeErr] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [alertType, setAlertType] = useState("");
    const [alertMsg, setAlertMsg] = useState("");

    const classes = useStyles();
    const classSweet = useStyleSweet();
    const classDrop = useSelectStyles();
    const dashboard = useDashboardStyles();

    const adminObj = JSON.parse(sessionStorage.getItem("sessionData"));

    useEffect(() => {
        async function fetchUser() {
            const api = `${localApi}/clientGroup/list/byAdminId/${adminObj?.id}`;
            const res = await fetch(api, {
                method: "GET",
                headers: { Authorization: `Basic ${credentials}` },
            });
            const data = await res.json();
            setItems(data?.filter((f) => f.type !== "Crm") || []);
        }
        fetchUser();
    }, [adminObj]);

    useEffect(() => {
        async function fetchType() {
            const api = `${localApi}/type/list`;
            const res = await fetch(api, {
                method: "GET",
                headers: { Authorization: `Basic ${credentials}` },
            });
            const data = await res.json();
            setTypeItem(
                data?.TypeList?.filter(
                    (item) => !["Control", "Admin", "Crm"].includes(item.title)
                ) || []
            );
        }
        fetchType();
    }, []);

    const handleBoots = async (selected) => {
        if (!selected?.value) return;

        const [_, mobile] = selected.value.split("-");
        const selectedItem = items.find((f) => f.mobile === mobile);

        if (!selectedItem) return;

        const api = `${localApi}/register/byMobile/${selectedItem.mobile}`;
        const res = await fetch(api, {
            method: "GET",
            headers: { Authorization: `Basic ${credentials}` },
        });
        const data = await res.json();
        setClientid(data);
        setSimpleSelect(selected);
    };

    const handleTypeChange = (event) => {
        setType(event.target.value);
        setTypeErr("");
    };

    const SubmitType = async () => {
        if (!type) {
            setTypeErr("Please select a type");
            return;
        }

        if (!clientid?.id) return;

        const payload = {
            typeId: type.typeId,
            type: type.title,
        };

        const res = await fetch(`${localApi}/register/updateType/byId/${clientid.id}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                Authorization: `Basic ${credentials}`,
            },
            body: JSON.stringify(payload),
        });

        const data = await res.json();
        if (data.message === "Data Updated Successfully !!!") {
            setAlertType("success");
            setAlertMsg("Successfully changed client type!");
            setSubmitted(true);
        }
    };

    const hideAlert = () => {
        setSubmitted(false);
        window.location.reload();
    };

    const selectStyle = {
        option: (provided) => ({ ...provided, padding: 10 }),
        menu: () => ({ color: "#d81b60" }),
        singleValue: (provided, state) => ({
            ...provided,
            opacity: state.isDisabled ? 0.5 : 1,
            transition: "opacity 300ms",
        }),
    };

    return (
        <div>
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={8}>
                    <Card>
                        <CardHeader color="rose" icon>
                            <CardIcon color="rose">
                                <BiEdit />
                            </CardIcon>
                            <h3 className={classes.cardIconTitle}>
                                <small>Select Client</small>
                            </h3>
                        </CardHeader>
                        <CardBody>
                            <GridContainer justify="center">
                                <GridItem xs={12} sm={8} md={8}>
                                    <label className={dashboard.selectLabel}>
                                        Select Company & Client Name
                                    </label>
                                    <Selects
                                        styles={selectStyle}
                                        placeholder="Select Company & Client Name..."
                                        value={simpleSelect}
                                        onChange={handleBoots}
                                        options={items.map((c) => ({
                                            label: c.company
                                                ? `${c.company}-${c.mobile}`
                                                : `${c.firstname} ${c.lastname}-${c.mobile}`,
                                            value: c.company
                                                ? `${c.company}-${c.mobile}`
                                                : `${c.firstname} ${c.lastname}-${c.mobile}`,
                                        }))}
                                    />
                                    <span style={{ color: "red" }}>{simpleSelectErr}</span>
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                    </Card>
                </GridItem>

                {submitted && (
                    <SweetAlert
                        type={alertType}
                        style={{ display: "block", marginTop: "-100px" }}
                        title={alertMsg}
                        onConfirm={hideAlert}
                        confirmBtnCssClass={`${classSweet.button} ${classSweet.success}`}
                    />
                )}

                {clientid && (
                    <GridItem xs={12} sm={12} md={5}>
                        <Card>
                            <CardBody>
                                <h4 style={{ textAlign: "center", fontWeight: "bold" }}>Client Type Change</h4>
                                <p className={classes.cardDescription}>
                                    <span style={{ fontWeight: "bold" }}>
                                        {clientid.company || `${clientid.firstname} ${clientid.lastname}`}</span>
                                </p>
                                <p className={classes.cardDescription}>
                                    {`${clientid.firstname} ${clientid.lastname}`}
                                    <br />
                                    {`${clientid.city}, ${clientid.state}, ${clientid.country}`}<br />
                                    <span style={{ color: "red" }}>{`Type - ${clientid.type}`}</span>

                                </p>

                                <GridContainer justify="center">
                                    <GridItem xs={12} sm={6}>
                                        <FormControl fullWidth className={classDrop.selectFormControl}>
                                            <InputLabel htmlFor="simple-select" className={classDrop.selectLabel}>
                                                Select Type
                                            </InputLabel>
                                            <Select
                                                MenuProps={{ className: classDrop.selectMenu }}
                                                classes={{ select: classDrop.select }}
                                                value={type}
                                                onChange={handleTypeChange}
                                                inputProps={{
                                                    name: "simpleSelect",
                                                    id: "simple-select",
                                                }}
                                            >
                                                <MenuItem disabled>Select Type</MenuItem>
                                                {typeItem
                                                    .filter((item) => item.title !== clientid.type)
                                                    .map((item) => (
                                                        <MenuItem
                                                            key={item.typeId}
                                                            value={item}
                                                            classes={{
                                                                root: classDrop.selectMenuItem,
                                                                selected: classDrop.selectMenuItemSelected,
                                                            }}
                                                        >
                                                            {item.title}
                                                        </MenuItem>
                                                    ))}
                                            </Select>
                                        </FormControl>
                                        <span style={{ color: "red" }}>{typeErr}</span>
                                    </GridItem>
                                </GridContainer>

                                <Button color="rose" onClick={SubmitType} className={classes.updateProfileButton}>
                                    Update
                                </Button>
                            </CardBody>
                        </Card>
                    </GridItem>
                )}
            </GridContainer>
        </div>
    );
}
